import { useCallback, useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { PageHeader, Panel } from "@/components/app/PageParts";
import { ComplianceProfileForm } from "@/components/app/ComplianceProfileForm";
import { ComplianceItem } from "@/components/app/ComplianceItem";
import { api, errorMessage } from "@/lib/api";

export default function Compliance() {
  const { workspace } = useOutletContext();
  const [d, setD] = useState(null);
  const [editing, setEditing] = useState(false);
  const load = useCallback(() => { api.get(`/workspaces/${workspace.id}/compliance`).then(({ data }) => setD(data)).catch((e) => toast.error(errorMessage(e))); }, [workspace.id]);
  useEffect(load, [load]);
  if (!d) return null;
  const p = d.profile;
  return (
    <div data-testid="compliance-page">
      <PageHeader eyebrow="California" title="Business compliance" subtitle="A checklist for California stock corporations and LLCs, built from official sources." />
      <p data-testid="compliance-coverage-note" className="mb-6 rounded-md border border-gold/40 bg-gold-light/40 p-3 text-sm text-slate-700">{d.coverage} Suggested dates stay unconfirmed until you check them and save them as deadlines.</p>
      {(!p || editing) && d.can_edit && !workspace.is_sample ? (
        <Panel title="Business profile" testId="compliance-profile-panel"><ComplianceProfileForm workspace={workspace} profile={p} entityTypes={d.entity_types} onSaved={() => { setEditing(false); load(); }} /></Panel>
      ) : p ? (
        <div className="mb-6 flex flex-wrap items-center gap-3 rounded-xl border bg-white p-4 text-sm" data-testid="compliance-profile-summary">
          <strong className="text-navy">{d.entity_types[p.entity_type]}</strong>
          <span className="text-slate-600">Registered {p.registration_month}/{p.registration_year}{p.sos_entity_number && ` · SOS #${p.sos_entity_number}`} · Fiscal year ends month {p.fiscal_year_end_month}</span>
          {d.can_edit && <button type="button" onClick={() => setEditing(true)} className="ml-auto text-navy underline" data-testid="compliance-profile-edit">Edit</button>}
        </div>
      ) : <p className="text-sm text-slate-600" data-testid="compliance-no-profile">{workspace.is_sample ? "Business profiles can't be saved in the sample workspace." : "The workspace owner hasn't added a business profile yet."}</p>}
      {p && !editing && <ul className="mt-6 space-y-4" data-testid="compliance-checklist">{d.items.map((i) => <ComplianceItem key={i.key} workspace={workspace} item={i} onChanged={load} />)}</ul>}
    </div>
  );
}
